import React, { useEffect, useState } from "react";
import Spinner from "../Header/Spinner/Spinner";

import Project from "./Project";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [spinner, setSpinner] = useState(true);
  useEffect(() => {
    fetch("https://thawing-earth-30870.herokuapp.com/projects")
      .then((res) => res.json())
      .then((data) => {
        setProjects(data);
        setSpinner(false);
      });
  }, []);
  if (spinner) {
    return <Spinner />;
  }
  return (
    <div id="project" className="max-w-[1100px] mx-auto py-20 ">
      <div className="title mt-8  mb-8 lg:mt-12 lg:mb-20 ">
        <h2 className="lg:text-6xl text-4xl text-primary font-bold tracking-widest   title-project">
          Projects
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project) => (
          <Project key={project._id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
